import { useEffect, useRef } from 'react';

function publishCustomCss(parent: Element | null, styles: string, styleTagId: string) {
  if (!parent) {
    return;
  }

  const style = document.createElement('style');
  style.setAttribute('id', styleTagId);

  style.textContent = styles;

  const origStyle = (Array.from(parent.childNodes) as HTMLElement[]).find(
    (node) => node.tagName === 'STYLE' && !node.id
  ) as HTMLStyleElement;

  try {
    const existing = parent.querySelector(`#${styleTagId}`);
    // remove existing

    if (existing) {
      existing.remove();
    }

    if (origStyle?.nextSibling) {
      parent.insertBefore(style, origStyle?.nextSibling);
    } else if (parent.childNodes?.[1]) {
      parent.insertBefore(style, parent.childNodes[1]);
    } else {
      // we didn't find anything loaded yet.
      parent.appendChild(style);
    }
  } catch (err) {
    console.warn('Error appending custom css to shadow root', err);
  }
}

export const useJustifiOverrideStyles = ({
  selector,
  overrideStyles,
  dependencies,
  styleTagId = 'justifi-custom-css',
}: {
  selector: () => HTMLElement | null | undefined;
  overrideStyles: string;
  dependencies: any[];
  styleTagId?: string;
}) => {
  const attemptsRef = useRef(0);
  /**
   * Publish CSS on mount or re-render (when main mounting props change).
   */
  useEffect(() => {
    let id: NodeJS.Timeout | null = null;

    const attemptToPublishCustomCss = () => {
      const rootElement = selector();

      if (rootElement) {
        publishCustomCss(rootElement, overrideStyles, styleTagId);
      } else if (attemptsRef.current < 10) {
        id = setTimeout(() => {
          attemptsRef.current++;
          attemptToPublishCustomCss();
        }, 250);
      }
    };

    attemptToPublishCustomCss();

    // Cleanup
    return () => {
      id && clearTimeout(id);
    };
  }, dependencies);
};
